import { formatCurrencyCell } from '../../shared/format-currency.js';
import { signedAmount } from './../../shared/transaction-balance.js';
import { TRANSACTION_TYPE_NAMES } from './../../shared/transaction-types.js';

/**
 * Column definitions for the schedule list table.
 * Used by the web renderer.
 *
 * - `align`: text alignment (`'right'` or omitted for left).
 * - `defaultSortDirection`: `-1` for descending, `1` for ascending.
 *
 * @typedef {{ id: string, transactionType: string, description: string, estimatedAmount?: number|null, frequency?: string|null, startDate: string, endDate?: string|null, occurrenceCount: number, nextDate?: string|null, displayAccount?: string, displayFreq?: string, currencySymbol?: string, currencyDecimalPlaces?: number, createdAt: string, updatedAt: string }} ScheduleRow
 */

/** @type {Array<{ key: string, label: string, type: string, align?: string, defaultSortDirection?: number, priority?: 1|2|3, getValue: (c: any) => any, getDisplayValue?: (c: any) => string, getSortValue?: (c: any) => any, getSortTieBreaker?: (c: any) => any, tieBreakerDirection?: 1|-1, filterType?: string, filterOptions?: string[], linkTo?: (row: any) => string|undefined, getCurrency?: (row: any) => { value: number, decimalPlaces: number, symbol: string } | null }>} */
export const SCHEDULE_COLUMNS = [
	{ key: 'nextDate', label: 'Next', type: 'date', defaultSortDirection: 1, priority: 1, getValue: (s) => s.nextDate || '\u2014' },
	{ key: 'displayAccount', label: 'Account', type: 'text', priority: 2, getValue: (s) => s.displayAccount || '', filterType: 'select', linkTo: (s) => (s.accountId || s.sourceAccountId) ? '/accounts/' + (s.accountId || s.sourceAccountId) : undefined },
	{ key: 'transactionType', label: 'Type', type: 'text', priority: 1, getValue: (s) => s.transactionType, filterType: 'select', filterOptions: [...TRANSACTION_TYPE_NAMES] },
	{ key: 'displayAmount', label: 'Amount', type: 'currency', priority: 1,
		getValue: (s) => {
			if (s.estimatedAmount === null || s.estimatedAmount === undefined) { return '\u2014'; }
			const val = signedAmount(s.estimatedAmount, s.transactionType);
			return formatCurrencyCell(val, s.currencyDecimalPlaces, s.currencySymbol);
		},
		getSortValue: (s) => {
			const amt = s.baseEquivalent ?? s.estimatedAmount ?? 0;
			return signedAmount(amt, s.transactionType);
		},
		getCurrency: (s) => {
			if (s.estimatedAmount === null || s.estimatedAmount === undefined || s.currencyDecimalPlaces === undefined || !s.currencySymbol) { return null; }
			const val = signedAmount(s.estimatedAmount, s.transactionType);
			return { value: val, decimalPlaces: s.currencyDecimalPlaces, symbol: s.currencySymbol };
		},
	},
	{ key: 'displayFreq', label: 'Freq', type: 'text', priority: 3, getValue: (s) => s.displayFreq || '', filterType: 'select', filterOptions: ['Monthly', 'Quarterly', 'Yearly'] },
	{ key: 'description', label: 'Description', type: 'text', priority: 2, getValue: (s) => s.description },
];
